import { createGenericStore } from '@/stores/utils/genericStore.js'

const businessSystemCategoryStoreOptions = {
  state: () => ({
    customPropertyExample: null
  }),
  getters: {
  },
  actions: {
  }
}

export const useBusinessSystemCategoryStore = createGenericStore(
  'businessSystemCategory',
  '/api/v1/business-system-categories',
  businessSystemCategoryStoreOptions
)
